import { Tag, Tooltip } from '@blueprintjs/core';
import { IUser } from '@axo/shared/data-access/provider';
import { getLocalPartOfEmail } from '../../utils/getLocalPartOfEmail';
import styles from './Navigation.module.css';

interface ILogInApplication {
  user: IUser;
}
export function LogInStatus({ user }: ILogInApplication) {
  return (
    <Tooltip
      content={
        <p>
          Logged in as <strong>{user.email}</strong>.
          <br />(
          {user.roles
            .map((x) => [x.Name, x.Country].filter((p) => p).join(' / '))
            .join(', ')}
          )
        </p>
      }
    >
      <Tag round className={styles.logInTag}>
        {getLocalPartOfEmail(user.email)}
      </Tag>
    </Tooltip>
  );
}
